import type { LinkSelfDto } from '@hcr/api/optimizely'
import type { Link } from '@hcr/ui'

export const createLinkSelf = (dto: LinkSelfDto): Link => ({
  isExternal: false,
  label: dto.label,
  to: dto.url,
})
